import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouteService } from '../../services/route.service';
import { UserService } from '../../services/user.service';
import { StorageService } from '../../services/storage.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { NgClass, NgIf } from '@angular/common';
import { Apps } from '../../interfaces/apps.interface';
import { environment } from '../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'wm-libs-auth-buttons',
  templateUrl: './auth-buttons.component.html',
  styleUrls: ['./auth-buttons.component.scss'],
  standalone: true,
  imports: [NgIf, MatButtonModule, NgClass, RouterLink, RouterLinkActive, TranslateModule],
})
export class AuthButtonsComponent {
  @Input() isMobile!: boolean | null;
  @Input() isAuth!: boolean | null;
  @Input() isDarkMode!: boolean | null;
  @Input() wrap = false;
  @Input() app!: Apps;

  @Output() buttonClick = new EventEmitter<void>();

  env = environment;

  constructor(private userService: UserService, private authService: AuthService, private storageService: StorageService, private routeService: RouteService) {}

  logOut() {
    this.buttonClick.emit();

    this.authService.logout().subscribe(() => {
      this.storageService.removeToken();
      this.userService.setAuthenticated(false);
      this.userService.setNeedTfa(false);

      switch (this.app) {
        case 'wm-tech':
          this.routeService.goToLogin();
          break;
        case 'wm-tech-mms':
          window.location.href = this.env.techDomain;
          break;
        case 'wm-tech-pool':
          window.location.href = this.env.techDomain;
          break;
        default:
          window.location.href = this.env.techDomain;
          break;
      }
    });
  }
}
